<template>
    <div class="relative pb-1 mt-4 mb-10 border-b font-display lg:mt-0 header">
      <span class="text-3xl font-bold tracking-widest uppercase"><slot name="title"></slot><span class="inline-block ml-3 text-xs font-thin capitalize text-secondary"><slot name="subtitle"></slot></span></span>
    </div>
</template>

<script>
export default {
  name: 'Header',
}
</script>
<style>
  .header:after {
      @apply bg-tertiary;
      content: '';
      width: 6rem;
      height: 1px;
      @apply absolute;
      bottom: -1px;
      @apply left-0;
  }
</style>
